export default __webpack_public_path__ + "static/favicon-29cf8f6b507ccead701f84f046b51501.ico";